import {Observable} from 'rxjs';
import {RestApiService} from '../../../../rest-api.service';
import {
    CalendarImportCommitRes,
    CalendarImportPreviewRes
} from '../../../../../contracts/v0/account/integrations/account.integrations.calendar.contracts';
import {ApiV0AccountCalendarIntegration} from './api.v0.crm.integrations.calendar';

export class ApiV0AccountIntegrationsCalendarImport {
    segment = '/import';

    constructor(
        integrations: ApiV0AccountCalendarIntegration,
        private rest: RestApiService
    ) {
        this.segment = integrations.segment + this.segment;
    }

    previewIcsFile(formData: FormData): Observable<CalendarImportPreviewRes> {
        return this.rest.post<FormData, CalendarImportPreviewRes>(
            `${this.segment}/ics`,
            CalendarImportPreviewRes,
            formData
        );
    }

    commitIcsFile(formData: FormData): Observable<CalendarImportCommitRes> {
        return this.rest.post<FormData, CalendarImportCommitRes>(
            `${this.segment}/ics/commit`,
            CalendarImportCommitRes,
            formData
        );
    }
}